/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CountyContext from '../../contexts/CountyContext';
import StoryContext from '../../contexts/StoryContext';
import { rdsSelect } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toPercent } from '../../modules/text';
import BarChart from '../BarChart';
import { getRatesByState } from './data';

function AveragePriceByNativityOfParents({ height = 300 }) {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const { countyCode, county } = useContext(CountyContext);
  const { primaryColor, secondaryColor } = useContext(StoryContext);

  useEffect(() => {
    setError(null);
    // function getRatesByState() {
    //   let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
    //   whereClause += composeWhereClause({});

    //   return rdsTabulate('ccdc', 'county_setting_group_rate_annual', {
    //     dims: 'state',
    //     measure: 'average_rate:AVG(rate)',
    //     where: whereClause,
    //     format: 'amcharts',
    //     inject: true,
    //   }, true);
    // }

    function getMedianHouseholdIncome() {
      let dataProduct = 'acs_sams_state_wide';
      let where = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
      if (countyCode) {
        dataProduct = 'acs_sams_county_wide';
        where += ` AND county_fips=${countyCode} AND (county_suppressed=0 OR county_suppressed=NULL)`;
      }
      return rdsSelect('3rdparty', dataProduct, {
        cols: ['inc_fam_married_oneortwoparents_native2', 'inc_fam_nospouse_oneortwoparents_native2', 'inc_fam_married_oneortwoparents_foreign1', 'inc_fam_nospouse_oneortwoparents_foreign1'].join(','),
        where,
        format: 'amcharts',
        inject: false,
      });
    }

    if (stateCode && states[stateCode.toUpperCase()]) {
      Promise.all([getRatesByState(stateCode), getMedianHouseholdIncome()])
        .then((responses) => {
          const rate = responses[0].parsedBody.dataProvider[0].average_rate;

          const incomes = responses[1].parsedBody.dataProvider[0];
          setData([
            { groupKey: 'Native-born parent(s)', 'Married-couple families': (rate / incomes.inc_fam_married_oneortwoparents_native2), 'Single-parent families': (rate / incomes.inc_fam_nospouse_oneortwoparents_native2) },
            { groupKey: 'Foreign-born parent(s)', 'Married-couple families': (rate / incomes.inc_fam_married_oneortwoparents_foreign1), 'Single-parent families': (rate / incomes.inc_fam_nospouse_oneortwoparents_foreign1) },
          ]);
        })
        .catch((err) => {
          setError(err);
        })
        .finally(() => {
          setReady(true);
        });
    }
  }, [stateCode, countyCode]);

  const keys = ['Married-couple families', 'Single-parent families'];
  const groupKey = 'groupKey';

  let title = 'Nativity of Parents';
  if (county) {
    title += ` - ${county} County`;
  }

  // const tooltipTemplate = `<b>#VALUE#</b> of the household income for a <b>#GROUPING#</b> <b>#FAMILY#</b> goes to pay for child care.
  // `;

  const formatterFunction = function formatterFunction(payload) {
    if (payload.value) {
      return `<b>${toPercent(payload.value)}</b> of the household income for a <b>${payload.payload.groupKey.toLowerCase()}</b>
     <b>${payload.dataKey.toLowerCase().replace('families', 'family')}</b> goes to pay for child care.`;
    }
    return 'Insufficient sample size';
  };

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <BarChart
        valueFormatter={toPercent}
        formatterFunction={formatterFunction}
        height={height}
        ready={ready}
        data={data}
        keys={keys}
        groupKey={groupKey}
        title={title}
        colors={[primaryColor, secondaryColor]}
      />
    </>
  );
}

export default AveragePriceByNativityOfParents;
